package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_15_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Horbin Courthammer greets the heroes in the morning. Breakfast smells great! Nobody thinks to thank Falorn who suggested they stay at the Gleaming Horde instead of the Powerglow tower. Typical. Dirk and Brauna Hollytoes discuss the heroes’ travel plans.  Bondōvriar is a bigger city than Malus. It is the 2nd or 3rd largest city on the continent. The city’s leadership is chosen in a most unusual way — citizens “vote” for their preferred leader, and the one with most “votes” becomes leader.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("Zolnur Zizzdek of the Roving Peers is to meet the heroes in Bondōvriar.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes teleport to Bondōvriar where they are greeted by a wizardly, academic gnome dressed in purple, who introduces himself as Zordifraz Gribblehook — call me “Zordie.” Beside him is Zolnur Zizzdek, a human dressed in well-loved clothing.  The heroes are advised that Marifus Millgold’s Marvelous Magics is a good place for adventurers to shop and that inns are filling up due to a number of traveling mages currently visiting the city.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Many guards are present and visible in the city. The heroes’ travels take them close to the inner city walls, which appear well engineered and about 15 feet thick. Soon they arrive at Marifus Millgold’s Marvelous Magics, where they are greeted by the man himself, Marifus Millgold. Bigglesworth buys a new cloak. The heroes receive several referrals:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Drolo Potterson - magics and potions vender")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Flip Chittle sundries for quality chiton for armor")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Flanka Longboy’s clothing shop")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes head to The Grey Goat Inn. Zolnur Zizzdek introduces the heroes to Kyle. Bigglesworth says the heroes need two rooms and Falorn pays. Zolnur suggests that the heroes should not tell the local government that they plan to extract an artifact from their lands. Zolnur says he can arrange a guide to take the heroes as far as Seshiss. He warns that in the swamp there are:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Acid Trolls")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Slaad")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Snakes")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Kuo-toa")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sahuagin")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The locals eat rice. The heroes tell Zolnur that they plan to depart tomorrow. Zolnur leaves to do something.")
    }
}
